// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tqXR","input":"styles_input__1NLE7"};